import { useEffect, useState } from 'react';

import { ProprietaireCourantDto } from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';

interface UseProprietaireInfos {
  proprietaireInfos: ProprietaireCourantDto | undefined;
  loading: boolean;
}

export function useProprietaireInfos(dossierId: string): UseProprietaireInfos {
  const [proprietaireInfos, setProprietaireInfos] = useState<
    ProprietaireCourantDto | undefined
  >(undefined);
  const [loading, setLoading] = useState(true);

  const { DossierControllerApi } = useApi();

  useEffect(() => {
    DossierControllerApi.getInfosProprietaireCourantByIdUsingGET(dossierId)
      .then((infos: ProprietaireCourantDto) => {
        setProprietaireInfos(infos);
      })
      .catch((error: Error) => {
        console.error('Error fetching proprietaire infos:', error);
        setProprietaireInfos(undefined);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dossierId]);

  return { proprietaireInfos, loading };
}
